// Ported from vlookup-dramatic/app/find-a-mentor/hero-carousel.tsx by scripts/revamp/port-design.js
import React, { useEffect, useRef, useState } from "react";
import Image from "../../components/image";
import { ChevronLeft, ChevronRight } from "../../lib/icons";
import { findMentorHero } from "../../lib/content";
import { cn } from "../../lib/utils";
const AUTO_MS = 4500;
const photos = findMentorHero.photos;
export function FindMentorHeroCarousel() {
    const [active, setActive] = useState(0);
    const reducedRef = useRef(false);
    const pausedRef = useRef(false);
    useEffect(() => {
        reducedRef.current = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }, []);
    useEffect(() => {
        if (photos.length < 2 || reducedRef.current)
            return;
        const id = window.setInterval(() => {
            if (pausedRef.current)
                return;
            setActive((a) => (a + 1) % photos.length);
        }, AUTO_MS);
        return () => window.clearInterval(id);
    }, []);
    const go = (dir) => setActive((a) => (a + dir + photos.length) % photos.length);
    return (<div className="relative mx-auto w-full max-w-[520px] md:max-w-[600px] lg:max-w-none" onMouseEnter={() => {
            pausedRef.current = true;
        }} onMouseLeave={() => {
            pausedRef.current = false;
        }}>
      {/* Taller than 16:9 below lg so faces aren’t cropped; portrait returns at lg. */}
      <div className="mentor-hero-frame relative overflow-hidden rounded-[2rem] bg-cream-deep shadow-[0_30px_80px_-30px_rgba(26,58,92,0.35)]">
        {photos.map((p, i) => (<Image key={p.src} src={p.src} alt={p.alt} fill sizes="(max-width: 1024px) 90vw, 45vw" priority={i === 0} className={cn("object-cover object-top transition-opacity duration-700 ease-out motion-reduce:transition-none", i === active ? "opacity-100" : "opacity-0")}/>))}

        <button type="button" aria-label="Previous photo" onClick={() => go(-1)} className="absolute left-3 top-1/2 flex size-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/85 text-heading shadow-sm backdrop-blur-sm transition-colors hover:bg-white md:size-10">
          <ChevronLeft className="size-4"/>
        </button>
        <button type="button" aria-label="Next photo" onClick={() => go(1)} className="absolute right-3 top-1/2 flex size-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/85 text-heading shadow-sm backdrop-blur-sm transition-colors hover:bg-white md:size-10">
          <ChevronRight className="size-4"/>
        </button>

        <div className="absolute bottom-4 left-0 right-0 flex items-center justify-center gap-1.5">
          {photos.map((p, i) => (<button key={p.src} type="button" aria-label={`Show photo ${i + 1} of ${photos.length}`} aria-current={i === active} onClick={() => setActive(i)} className={cn("h-2 rounded-full transition-all", i === active
                ? "w-6 bg-white"
                : "w-2 bg-white/50 hover:bg-white/80")}/>))}
        </div>
      </div>
    </div>);
}
